import { render } from "./processPaymentModal.vue?vue&type=template&id=56da6540"
import script from "./processPaymentModal.vue?vue&type=script&lang=js"
export * from "./processPaymentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__